// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class SearchRequestType extends TrackingModel {
	public SearchRequestTypeId: number = 0;
	public UID: string = "";
	public Description?: string;
}